export default __webpack_public_path__ + "static/media/abld_science.f76a510dc07f3ff3d4d6ee7fe89f81ce.svg";